// extracted by mini-css-extract-plugin
export default {"Socicon":"footer_Socicon__10sBN","list":"footer_list__iu-Ob","div1":"footer_div1__Oq8q1"};